__turbopack_context__.v({
  "banner": "catalog-grid-module-scss-module__qnJSJa__banner",
  "inner": "catalog-grid-module-scss-module__qnJSJa__inner",
  "item": "catalog-grid-module-scss-module__qnJSJa__item",
  "section": "catalog-grid-module-scss-module__qnJSJa__section",
});
